<template>
  <div class="my_show_num">
    <span class="my_show_num_title" :style="`flex: 0 0 ${!Number.isNaN(Number(titleWidth)) ? titleWidth + 'px' : titleWidth}`">{{
      title
    }}</span>
    <div class="input_wrapper">
      <my_input_int_number
        v-model="num"
        :min="1"
        :max="50"
        :disabled="isShowAll"
        style="width: 60px"
      ></my_input_int_number>{{$t('components_my_img_selecter_font_icon_store_2321')}}</div>
    <div class="checkbox_wrapper">
      <el-checkbox v-model="isShowAll">{{ allTitle }}</el-checkbox>
      <el-popover
        placement="top"
        trigger="hover"
        width="280"
        :content="tips"
        transition="zoom"
      >
        <span class="icon_info" slot="reference">?</span>
      </el-popover>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

export default {
  name: "my_show_num",
  props: {
    title: {
      type: String,
      default: i18n.t('components_my_show_num_index_2447'),
    },
    titleWidth: {
      type: String,
      default: "40",
    },
    inputValue: {
      type: String,
      default: "",
    },
    checkboxValue: {
      type: Boolean,
      default: true,
    },
    allTitle: {
      type: String,
      default: i18n.t('components_my_show_num_index_2448'),
    },
    showNum: {
      type: Number,
      default: 1,
    },
    showAll: {
      type: Boolean,
      default: false,
    },
    showType: {
      type: Number,
      default: 1,
    },
  },
  watch: {
    showNum(val) {
      this.num = val;
    },
    num(val) {
      this.$emit("update:showNum", val);
    },
    showAll(val) {
      this.isShowAll = val;
    },
    isShowAll(val) {
      this.$emit("update:showAll", val);
    },
    showType(val) {
      this.changeTips(val)
    },
  },
  data() {
    return {
      tips: i18n.t('components_my_show_num_index_2449'),
      num: this.showNum,
      isShowAll: this.showAll,
    };
  },
  mounted() {
    this.changeTips(this.showType)
  },
  methods: {
    changeTips(val) {
      let tipsTxt = i18n.t('widgets_basic_article_classification_edit_333');
      if (val === 0) tipsTxt = i18n.t('widgets_basic_classification_edit_482');
      if (val === 1) tipsTxt = i18n.t('widgets_basic_article_classification_edit_333');
      if (val === 2) tipsTxt = i18n.t('widgets_basic_article_classification_edit_335');
      if (val === 3) tipsTxt = i18n.t('widgets_basic_article_classification_edit_334');
      if (val === 11) tipsTxt = i18n.t('view_download_index_181');
      this.tips = i18n.t('components_my_show_num_index_2450', [tipsTxt])
    },
  },
};
</script>

<style lang="scss" scoped>
.my_show_num {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 8px;
  .my_show_num_title {
    display: inline-block;
    font-size: 13px;
    text-align: right;
    overflow: hidden;
    height: 32px;
    line-height: 32px;
  }
  .input_wrapper {
    margin-right: 20px;
  }
  .icon_info {
    border: 1px solid #cfd3db;
    color: #cfd3db;
    flex: 0 0 18px;
    width: 18px;
    font-size: 13px;
    height: 18px;
    display: inline-block;
    border-radius: 50%;
    text-align: center;
    line-height: 18px;
    cursor: pointer;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/my_show_num/index.vue